module.exports = __webpack_public_path__ + "static/media/img_anli1@2x.17b7f091.png";